// ── Clinic Sound Utilities ────────────────────────────────────────────────────
// All sounds use Web Audio API — no external files required.
// Fails silently if browser blocks audio (user hasn't interacted yet).

function getCtx() {
  try {
    return new (window.AudioContext || window.webkitAudioContext)();
  } catch { return null; }
}

function tone(ctx, freq, type, startTime, duration, gain) {
  const osc = ctx.createOscillator();
  const g   = ctx.createGain();
  osc.connect(g); g.connect(ctx.destination);
  osc.frequency.value = freq; osc.type = type;
  g.gain.setValueAtTime(gain, startTime);
  g.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
  osc.start(startTime); osc.stop(startTime + duration);
}

/** Ding-dong chime — for reception hearing next patient called */
export function playNextPatientChime(volume = 0.8) {
  const ctx = getCtx(); if (!ctx) return;
  const t = ctx.currentTime;
  tone(ctx, 880, 'sine', t,       0.5, volume);   // high note
  tone(ctx, 660, 'sine', t + 0.3, 0.7, volume);   // lower note, holds longer
  tone(ctx, 550, 'sine', t + 0.7, 0.5, volume * 0.6); // soft tail
}

/** Urgent bell ring — reception hearing doctor's call-for-help */
export function playReceptionBell(volume = 1.0) {
  const ctx = getCtx(); if (!ctx) return;
  const t = ctx.currentTime;
  // Alternating urgent ring: beep-beep-beep
  [0, 0.25, 0.5, 0.75, 1.0].forEach((offset, i) => {
    tone(ctx, i % 2 === 0 ? 1047 : 880, 'square', t + offset, 0.18, volume * 0.5);
  });
}

/** Soft muted tick — optional very quiet feedback for doctor */
export function playDocMutedTick() {
  const ctx = getCtx(); if (!ctx) return;
  tone(ctx, 440, 'sine', ctx.currentTime, 0.1, 0.05);
}
